import { useQuery } from "@tanstack/react-query";
import {
  CompaniesAdminControllerGetAdminCompanies200Response,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_COMPANIES } from "../domain";

import { companiesAdminApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_ADMIN_COMPANIES = "GET_ADMIN_COMPANIES";

type GetAdminCompaniesProps = {
  search?: string;
  pageNumber?: number;
  pageSize?: number;
};

const allowedRoles = [UserRole.Admin];

const getAdminCompanies = async (
  props?: GetAdminCompaniesProps,
): Promise<CompaniesAdminControllerGetAdminCompanies200Response | undefined> => {
  const response = await companiesAdminApi.companiesAdminControllerGetAdminCompanies(
    props?.search,
    undefined,
    undefined,
    props?.pageNumber,
    props?.pageSize,
  );

  return response.data;
};

export const useGetAdminCompanies = (
  user: UserProfileDto | null,
  props?: GetAdminCompaniesProps,
): {
  adminCompanies?: CompaniesAdminControllerGetAdminCompanies200Response;
  companiesEnabled: boolean;
  isPendingGetAdminCompanies: boolean;
  refetch: () => void;
} => {
  const enabled = roleGuard(user, allowedRoles);

  const { data, isPending, refetch } = useQuery({
    queryKey: [DOMAIN_COMPANIES, ACTION_GET_ADMIN_COMPANIES, props],
    queryFn: () => getAdminCompanies(props),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    adminCompanies: data,
    companiesEnabled: enabled,
    isPendingGetAdminCompanies: isPending,
    refetch,
  };
};
